<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">设备出库单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="small" type="primary" @click="addClick">新增出库单</el-button>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="设备出库单" name="1"></el-tab-pane>
            <el-tab-pane label="已出库" name="2"></el-tab-pane>
            <el-tab-pane label="已撤销" name="0"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="id" label="订单编号" ></el-table-column>
            <el-table-column  prop="status" label="订单状态" >
                <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">创建成功</div>
                    <div v-if="scope.row.status == 2">已出库</div>
                    <div v-if="scope.row.status == 0">已撤销</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="创建时间" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="updatedAt" label="撤销时间" v-if="activeName == 0">
                <template slot-scope="scope">
                    <div>{{scope.row.updatedAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="出库时间" v-if="activeName == 2">
                <template slot-scope="scope">
                    <div>{{scope.row.updatedAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createName" v-if="activeName == 1" label="创建人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateName" v-if="activeName == 0" label="撤销人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateName" v-if="activeName == 2" label="出库人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="total"  label="出库设备数量" >
                <template slot-scope="scope">
                    <div>{{scope.row.total}}台</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="styleName" label="款式" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="distributorName" label="一级代理商" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="saleOrderId" label="销售订单编号" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-if="scope.row.status == 1" v-preventReClick @click="revokeClick(scope.$index, scope.row)">撤销</el-button>
                <el-button size="mini" type="text" v-if="scope.row.status == 1" v-preventReClick @click="OutboundClick(scope.$index, scope.row)">出库</el-button>
                <el-button size="mini" type="text" v-if="scope.row.status == 2" v-preventReClick @click="ModifyLogisticsClick(scope.$index, scope.row)">修改物流</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="200px" :model="QueryForm" :rules="rules" ref="QueryOrders">
                <el-form-item label="订单编号：">
                    <el-input size="small" v-model="QueryOrdersId" style="width:230px" auto-complete="off" placeholder="订单编号"></el-input>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="QueryOrders()">确定</el-button>
                </el-form-item>
            </el-form>
            <el-descriptions style="margin:20px auto;width:80%;" :column="1" :size="size" border>
                <el-descriptions-item label="订单编号">{{SaleOrderForm.id}}</el-descriptions-item>
                <el-descriptions-item label="销售设备数量">{{ SaleOrderForm.total }}台</el-descriptions-item>
                <el-descriptions-item label="已创建出库单的设备数量">{{ SaleOrderForm.outOrderTotal }}台</el-descriptions-item>
                <el-descriptions-item label="款式">{{ SaleOrderForm.styleName}}</el-descriptions-item>
                <el-descriptions-item label="一级代理商">{{ SaleOrderForm.distributorName }}</el-descriptions-item>
            </el-descriptions>
            <el-form label-width="200px" :model="addDeviceForm" :rules="rules" ref="addDeviceForm">
                <el-form-item label="出库设备数量：" prop="total">
                    <el-input size="small" v-model="addDeviceForm.total" style="width:230px" auto-complete="off" placeholder="请输入出库数量">
                        <template slot="append">台</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="收货人姓名：" prop="receiverName">
                    <el-input size="small" v-model="addDeviceForm.receiverName" style="width:230px" auto-complete="off" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="收货人手机号：" prop="receiverPhone">
                    <el-input size="small" v-model="addDeviceForm.receiverPhone" style="width:230px" auto-complete="off" placeholder="请输入收货人手机号"></el-input>
                </el-form-item>
                <el-form-item label="所在地区：" prop="receiverValue">
                    <el-cascader
                        v-model="addDeviceForm.receiverValue"
                        :options="proData"
                        :props="{
                            value:'label'
                        }"
                        @change="handleChange"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                    <el-input size="small" v-model="addDeviceForm.address" style="width:230px" auto-complete="off" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input size="small" v-model="addDeviceForm.remark" style="width:230px" auto-complete="off" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :disabled="QueryOrdersFlag" :loading="loading" class="title" @click="addDeviceSunmit('addDeviceForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="出库单详情" :visible.sync="detailsFlag" width="40%" @click="closeDialog">
            <el-descriptions class="margin-top" title="创建出库单信息" :column="2" :size="size">
                <el-descriptions-item label="订单编号">{{StorageOrder.id}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{ StorageOrder.createName }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ StorageOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="出库设备数量">{{ StorageOrder.total }}台</el-descriptions-item>
                <el-descriptions-item label="款式">{{ StorageOrder.styleName}}</el-descriptions-item>
                <el-descriptions-item label="一级代理商">{{ StorageOrder.distributorName }}</el-descriptions-item>
                <el-descriptions-item label="销售订单编号">{{ StorageOrder.saleOrderId }}</el-descriptions-item>
                <el-descriptions-item label="收货地址">{{ StorageOrder.receiverName }} {{ StorageOrder.receiverPhone }} {{ StorageOrder.receiverAddress }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ StorageOrder.remark }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" v-if="StorageOrder.status == 2" style="margin-top: 20px;" title="出库详情" :column="2" :size="size">
                <el-descriptions-item label="操作人">{{StorageOrder.updateName}}</el-descriptions-item>
                <el-descriptions-item label="出库时间">{{ StorageOrder.updatedAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="物流公司">{{logisticsForm.logisticsName}}</el-descriptions-item>
                <el-descriptions-item label="物流单号">{{ logisticsForm.logisticsId }}</el-descriptions-item>
                <el-descriptions-item label="设备详情">
                    <div>
                        <div style="display:flex">
                            <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">设备sn码</div>
                            <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">款式</div>
                        </div>
                        <div v-for=" item in machineList" :key="item">
                            <div style="display:flex">
                                <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">{{ item.machineId }}</div>
                                <div style="text-align:center;width:200px;border:1px solid #eee;line-height:40px">{{item.styleName}}</div>
                            </div>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions v-if="StorageOrder.status == 0" class="margin-top" style="margin-top: 20px;" title="撤销入库单信息" :column="2" :size="size">
                <el-descriptions-item label="操作人">{{StorageOrder.updateName}}</el-descriptions-item>
                <el-descriptions-item label="撤销时间">{{ StorageOrder.updatedAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{StorageOrder.remark}}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        
        <!-- 绑定机器 -->
        <el-dialog title="撤销出库单" :visible.sync="revokeFlag" width="25%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="remark" style="width:250px"  placeholder="备注"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="revokeFlag = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="revokeSubmit()">保存</el-button>
                </div>
        </el-dialog>

        <el-dialog :visible.sync="OutboundFlag" width="30%" @click="OutboundClose">
            <el-form label-width="120px" :model="OutboundFlag" :rules="rules" ref="OutboundFlag">
                <el-form-item label="">
                    <h3>需要出库{{machineTotal}}台设备，款式：{{styleName}}</h3>
                </el-form-item>
                <el-form-item label="设备sn码">
                    <el-input size="small" v-model="OutboundMachineId" style="width:230px" auto-complete="off" placeholder="请输入设备sn码"></el-input>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="addDeviceClick()">添加</el-button>
                </el-form-item>
                <el-form-item label="已添加sn码">
                    <div v-for=" (item , index ) in machineIdList" :key="index" style="display:flex;">
                        <div>{{ item }} {{styleName}}</div><div style="margin-left: 20px;color:red;cursor:pointer;" @click="deleteClick(index)">删除</div>
                    </div>
                </el-form-item>
            </el-form>
            <el-card class="box-card">
                <div class="box-card-commodity">
                    <div class="box-card-commodity-shou">收</div>
                    <div style="flex:1">
                        <div>{{ OutboundForm.receiverName }} {{ OutboundForm.receiverPhone }}</div>
                        <div>{{ OutboundForm.receiverAddress }}</div>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card" style="margin-top:30px">
                <el-form :inline="true" :model="sendOutGoodsForm" label-width="120px" class="user-search">
                    <el-form-item label="物流单号">
                        <el-input size="small" v-model="logisticsId" :disabled="editFlag" placeholder="物理单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司">
                        <el-input size="small" v-model="logisticsName" :disabled="editFlag" placeholder="物流公司"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="OutboundClose">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="OutboundSubmit()">保存</el-button>
            </div>
        </el-dialog>
        <!-- 修改物流 -->
        <el-dialog :visible.sync="ModifyLogisticsFlag" width="30%" @click="OutboundClose">
            <el-card class="box-card" style="margin-top:30px">
                <el-form :inline="true" :model="sendOutGoodsForm" label-width="120px" class="user-search">
                    <el-form-item label="物流单号">
                        <el-input size="small" v-model="logisticsId" :disabled="editFlag" placeholder="物理单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司">
                        <el-input size="small" v-model="logisticsName" :disabled="editFlag" placeholder="物流公司"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="ModifyLogisticsFlag = false,logisticsId = '',logisticsName = ''">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="ModifyLogisticsSubmit()">保存</el-button>
            </div>
        </el-dialog>
        
</div>
</template>
<script>
import { regionData  } from 'element-china-area-data'
import Pagination from '../../components/Pagination'
import { loadOutOrderList , getSaleOrderDetail , 
    getOutOrderDetail , revokeOutOrder , 
    checkMachineId , createOutOrder ,doOut, 
    saveLogistics  } from '../../api/userMG'
import { toRaw } from 'vue'
export default {
    data(){
        return{
            machineTotal:0,
            styleId:'',
            styleName:'',
            logisticsForm:{},
            ModifyLogisticsFlag:false,
            ModifyLogisticsForm:{},
            logisticsId:'',
            logisticsName:'',
            OutboundForm:{},
            OutboundFlag:false,
            OutboundMachineId:'',
            QueryOrdersFlag:true,
            QueryOrdersId:'',
            SaleOrderForm:{},
            value:'',
            proData:regionData,
            systemModeOperator:'',
            systemModeRange:{
                systemMode1:true,
                systemMode2:true,
                systemMode3:true,
            },
            systemMode:'',
            rules:{},
            revokeFlag:false,
            machineList:[],
            StorageOrder:{},
            addDeviceForm:{
                machineId:''
            },
            machineIdList:[],
            id:'',
            bindingFlag:false,
            activeName:"1",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            remark:'',
            rules: {
                total : [
                    { required: true, message: '请输入设备数量', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                price : [
                { required: true, message: '请输入每台设备售价', trigger: 'blur' },
                { message: '格式错误（小数点保留两位）', trigger: 'blur' , pattern:/^[0-9]+(.[0-9]{2})?$/ }
                ],
                remark : [
                { required: true, message: '请输入备注', trigger: 'blur' }
                ],
                receiverName: [
                { required: true, message: '请输入收货人姓名', trigger: 'blur' }
                ],
                receiverPhone: [
                { required: true, message: '请输入收货人手机号', trigger: 'blur' },
                {
                    pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
                    required: true,
                    message: '请输入正确的手机号',
                    trigger: 'blur'
                }
                ],
                receiverValue: [
                { required: true, message: '请选择所在地区', trigger: 'blur' }
                ],
                address: [
                { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                num: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        ModifyLogisticsClick(index , row){
            this.ModifyLogisticsFlag = true
            this.ModifyLogisticsForm = row
        },
        ModifyLogisticsSubmit(){
            saveLogistics({
                orderId:this.ModifyLogisticsForm.id,
                logisticsId:this.logisticsId ,
                logisticsName:this.logisticsName
            }).then(res=>{
                if(res.success){
                    this.logisticsId  = ""
                    this.logisticsName = ""
                    this.ModifyLogisticsFlag = false
                    this.$message.success('修改物流成功')
                }else {
                    this.$message.error(res.messages)
                }
            })
        },
        OutboundSubmit(){
            if(this.logisticsId == ''){
                this.$message.error('请输入物流单号')
            }else if(this.logisticsName == ''){
                this.$message.error('请输入物流公司')
            }else if(this.machineIdList.length < this.OutboundForm.total){
                this.$message.error(`请添加${this.OutboundForm.total - this.machineIdList.length}台设备`)
            }else{
                doOut({
                    id:this.OutboundForm.id,
                    machineIdList:this.machineIdList.join(';'),
                    logisticsId:this.logisticsId,
                    logisticsName:this.logisticsName
                }).then(res=>{
                    if(res.success){
                        this.$message.success('操作成功')
                        this.logisticsName = ''
                        this,this.logisticsId = ""
                        this.machineIdList = [],
                        this.OutboundForm = {}
                        this.getdata()
                        this.OutboundFlag = false
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }
        },
        OutboundClose(){
            this.OutboundMachineId = ''
            this.machineIdList = []
            this.OutboundFlag = false
        },
        addDeviceClick(){
            if(this.OutboundMachineId == ''){
                this.$message.error('设备sn码不能为空')
            }else{
                let pushFlag = false
                for(let item of this.machineIdList){
                    if(item == this.OutboundMachineId){
                        pushFlag = true
                    }
                }
                if(pushFlag == true){
                    this.$message.error('该设备sn码已添加')
                }else{
                    checkMachineId({
                        machineId:this.OutboundMachineId,
                        styleId:this.styleId,
                    }).then(res=>{
                        if(res.success){
                            if(res.isOk == 0){
                                this.$message.error('未找到该设备')
                            }else if(res.isOk == 2) {
                                this.$message.error('该设备sn码已出库')
                            }else if(res.isOk == 4) {
                                this.$message.error(res.messages)
                            }else if(res.isOk == 1) {
                                if(this.OutboundForm.total > this.machineIdList.length){
                                    this.machineIdList.unshift(this.OutboundMachineId)
                                    this.OutboundMachineId = ''
                                }else {
                                    this.$message.error(`出库设备最多可添加${this.OutboundForm.total}`)
                                }
                            }
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                }
            }
        },
        OutboundClick(index , row){
            console.log(row)
            this.machineIdList = []
            this.OutboundMachineId = ''
            this.styleName = row.styleName
            this.styleId = row.styleId
            this.machineTotal = row.total
            this.OutboundFlag = true
            this.OutboundForm = row
        },
        QueryOrders(){
            getSaleOrderDetail({
                id:this.QueryOrdersId
            }).then(res=>{
                if(res.success){
                    if(res.SaleOrder.status == 1){
                        if(Number(res.SaleOrder.total) > Number(res.SaleOrder.outOrderTotal)){
                            this.QueryOrdersFlag = false
                            this.SaleOrderForm = res.SaleOrder
                        }else {
                            
                            this.$message.error('销售单的设备都已出库')
                            this.QueryOrdersFlag = true
                        }
                    }else {
                        this.$message.error('销售单已撤销')
                    }
                }else{
                    this.$message.error('未找到销售单')
                }
            })
        },
        systemModeInput(e){
            if(e == 1){
                this.systemModeRange = {
                    systemMode1:false,
                    systemMode2:false,
                    systemMode3:false,
                }
                this.systemMode = ''
            }else {
                this.systemModeRange = {
                    systemMode1:true,
                    systemMode2:true,
                    systemMode3:true,
                }
            }
        },
        handleClick(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        addDeviceSunmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.addDeviceForm.total > (this.SaleOrderForm.total - this.SaleOrderForm.outOrderTotal)){
                        this.$message.error('销售单剩余可出库设备不足')
                    }else {
                        createOutOrder({
                            saleOrderId:this.QueryOrdersId,
                            total:this.addDeviceForm.total,
                            receiverName:this.addDeviceForm.receiverName,
                            receiverPhone:this.addDeviceForm.receiverPhone,
                            remark:this.addDeviceForm.remark,
                            receiverAddress:`${this.addDeviceForm.receiverValue[0]}${this.addDeviceForm.receiverValue[1]}${this.addDeviceForm.receiverValue[2]}${this.addDeviceForm.address}`
                        }).then(res=>{
                            if(res.success){
                                this.$message.success('创建成功')
                                this.addDeviceForm = {
                                    total:'',
                                    receiverName:'',
                                    receiverPhone:'',
                                    remark:'',
                                    receiverValue:'',
                                    address:''
                                }
                                this.QueryOrdersId = '',
                                this.SaleOrderForm = {}
                                this.editFormVisible = false
                                this.QueryOrdersFlag = true
                                this.getdata()
                            }else {
                                this.$message.error(res.messages)
                            }
                        }) 
                    }
                } else {
                    return false
                }
            })
        },
        revokeSubmit(){
            if(this.remark == ''){
                this.$message.error("请填写备注")
            }else{
                revokeOutOrder({
                    id:this.id,
                    revokeRemark:this.remark
                }).then(res=>{
                    if(res.success){
                        this.remark = ''
                        this.$message.success('撤销成功')
                        this.revokeFlag = false
                        this.getdata()
                    }else {
                        this.$message.error(res.messages)
                    }
                })
            }
        },  
        revokeClick(index , row){
            this.remark = ''
            this.revokeFlag = true
            this.id = row.id
        },
        
        deleteClick(index){
            this.machineIdList.splice(index , 1)
        },
        handleEdit(index , row){
            getOutOrderDetail({
                id:row.id
            }).then(res=>{
                if(res.success){
                    this.detailsFlag = true
                    this.StorageOrder = res.SaleOrder
                    this.machineList = res.machineList
                    this.logisticsForm = res.logistics != undefined?res.logistics:{}
                    // this.editForm = row
                }else {
                    this.$message.error(res.messages)
                }
            })
            
        },
        addClick(){
            this.editFormVisible = true
            this.QueryOrdersId = ''
            this.SaleOrderForm = {}
            this.addDeviceForm = {}
            this.addDeviceForm.machineId = ''
            this.machineIdList = []
        },
        closeDialog(){
            this.editFormVisible = false
            this.addDeviceForm = {
                total:'',
                receiverName:'',
                receiverPhone:'',
                receiverValue:'',
                address:'',
                remark:'',

            }
            this.QueryOrdersFlag = true
            this.QueryOrdersId = '',
            this.SaleOrderForm = {}
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadOutOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                status:this.activeName
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .box-card-commodity{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .line_height{
    line-height: 45px;
  }
  .box-card-commodity-shou{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;
    background: #8c939d;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    font-size: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/equipmentManagement/outboundOrder.vue